import es from'date-fns/locale/es/index';var locale={localize:es.localize,options:{weekStartsOn:0}};export default locale;
//# sourceMappingURL=esUS.js.map